import React from "react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import Routing from "./routes/Routing";

const App = () => {
  return (
    <div>
      <Routing />
    </div>
  );
};

export default App;
